export default "__VITE_ASSET__70cbd223__"